通用文本展示

<template>
  <el-form-item :label="title" :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="itemClass" v-if="isShow"
    :prop="field.FIELD_ID">
    <div class="text">
      <span v-html="showVal"></span>
      <el-button class="use-check-button" v-if="isShowButton" :disabled="buttonEnable" @click="clickButton">
        {{fieldButtonTxt || '校验'}}</el-button>
    </div>
  </el-form-item>
</template>

<script>
export default {
  data () {
    return {
      showVal: "",
      itemClass: "self-text",
    };
  },
  props: ["field", "index", "isBaseUI"],
  created () {
    //默认值改变，如果是字典则要转为对应中文
    this.initData(this.field.DEFAULT_VALUE);
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;
  },
  computed: {
    isShowButton: function () {
      return this.field.IS_SHOW_BUTTON;
    },
    //ljc
    fieldButtonTxt: {
      get: function () {
        return this.field.FIELD_BUTTON_TXT;
      },
      set: function () {

      }
    },
    title: function () {
      this.field.FIELD_TITLE = this.field.FIELD_TITLE.replace("\\n", "\n");
      return _.trim(this.field.FIELD_TITLE) ? this.field.FIELD_TITLE
        + (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":"]).length ? "" : "：") : "";
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
  },
  methods: {
    clickButton () {
      if (this.isBaseUI) {
        this.$emit("click-button");
      } else {
        let data = {};
        data["MODULE_ID"] = this.field.MODULE_ID;
        data["index"] = this.index;
        data["FIELD_ID"] = this.field.FIELD_ID;
        data["GROUP_ID"] = this.$parent.$parent.$parent.moduleItem.GROUP_ID;
        this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_CLICK, data);
      }
    },
    validatorField: function (rule, value, callback) { },
    initData: function (vals) {
      let newVal = "";
      //默认值改变，如果是字典则要转为对应中文
      if (vals != "" && _.isString(vals) && this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME.length) {
        let valueArr = vals.split(",");
        let spliceWord = valueArr.length > 1 ? ";" : "";
        valueArr.forEach(value => {
          let item = _.find(this.field.FIELD_DICT_NAME, { DICT_ITEM: value });
          newVal = newVal + (item && item.DICT_ITEM_NAME || value) + spliceWord;
        });
        consoleLog("newVal===", newVal);
      } else {
        newVal = vals;
      }
      this.showVal = newVal;
    }
  },
  watch: {
    fieldButtonTxt: function (val) {
      this.fieldButtonTxt = val;
    },
    "field.BUTTON_ENABLE": {
      handler (newVal, oldVal) {
        this.buttonEnable = newVal;
      },
      immediate: true
    },
    "field.DEFAULT_VALUE": {
      handler (val, oldVal) {
        //默认值改变，如果是字典则要转为对应中文
        this.initData(val);
      },
      immediate: true
    },
  }
};
</script>

<style lang="less">
.self-text {
  width: 100%;
  display: flex;
  .el-form-item__label {
    font-size: 20px;
    min-width: 170px;
    text-align: right;
  }
  .el-form-item__content {
    font-size: 20px;
    color: #000;
    flex: 1;
    .text {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/normalTextItem.vue